import { NICmsContentComponent, NICmsContentField } from '@icms/core/content';

export const LOGIN_VIEW_LAYOUT_CONFIG = <Omit<NICmsContentComponent.IMeta<NICmsContentComponent.IComponent>, 'type'>>{
    id: 'login-view-layout',
    onDemandOnly: true,
    block: {
        url: 'login-view-layout'
    },
    name: 'Login View Layout',
    description: 'Login view layout block',
    fields: [
        <NICmsContentField.IComponentsField>{
            key: 'componentsTop',
            type: NICmsContentField.EFieldType.components,
            title: 'Components Top',
            itemName: 'component',
            default: []
        },
        <NICmsContentField.IComponentsField>{
            key: 'componentsBottom',
            type: NICmsContentField.EFieldType.components,
            title: 'Components Bottom',
            itemName: 'component',
            default: []
        }
    ],
    initData: {
        componentsTop: [],
        componentsBottom: []
    }
};
